export default {
    "app.header": "Servicio de traducción Voyager",
    "about.header": "Sobre Voyager",
    "about.para": "Voyager es el nombre líder en servicios de traducción e interpretación. Con más de 30 años de experiencia, Voyager sabe lo que necesita en un servicio de traducción e interpretación. Hacemos que sea fácil y accesible obtener las traducciones que necesita, rápidamente.",
    "services.header": "Ofrecido servicios",
    "service.one": "Interpretación consecutiva",
    "service.two": "Interpretación simultánea",
    "service.three": "Contenido multilingüe de redes sociales",
    "service.four": "Traducción de documentos",
    "service.five": "Interpretación de salud pública",
    "service.six": "Interpretación jurídica",
    "prices.header": "Precios",
    "prices.para": "Los servicios de nuestros traductores e intérpretes estan etiqueta por hora.",
    "translator.para": "Traducción £9 por hora de trabajo",
    "interpreter.para": "Interpretación £10 / £15 por hora (consecutivo / simultáneo)"
};
